import { AxiosError } from 'axios';

import { STAGE_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { StageItem } from '@/types/stage.item.type';

export const getStageItemsByStageId = async (
  stageId: string
): Promise<ApiResponse<Array<StageItem>>> => {
  try {
    const response = await apiManager.get(`${STAGE_API_URL}/${stageId}/items`, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
